import { Calendar, Loader2 } from "lucide-react";

import { type FC, type JSX } from "react";
import { UpcomingAppointment } from "../../services/api/appointment/appointmentApi";
import { formatDateTime } from "../../services/api/calls/conversationsApi";

interface UpcomingAppointmentProps {
    upcomingAppointments: UpcomingAppointment[];
    isLoading?: boolean;
}


const UpComingAppointment: FC<UpcomingAppointmentProps> = ({ upcomingAppointments, isLoading }): JSX.Element => {
  return <>
    <div className="bg-white rounded-lg shadow-lg p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Upcoming Appointments</h3>
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-green-600" />
          </div>
        ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Patient</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Date & Time</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Type</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Status</th>
              </tr>
            </thead>
            <tbody>
              {upcomingAppointments?.map((appointment) => (
                <tr key={appointment.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-4">{appointment.user_name}</td>
                  <td className="py-3 px-4">
                    <div className="flex items-center space-x-1">
                      <Calendar className="w-4 h-4 text-gray-400" />
                      <span>{formatDateTime(appointment.date.toString())}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800`}>
                      {'consultation'}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800`}>
                      {'scheduled'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
  </>;
}

export default UpComingAppointment;